import { Box, Typography } from "@material-ui/core";
import { forwardRef, ForwardRefExoticComponent } from "react";
import { useRedirect } from "react-admin";
import { useSelector } from "react-redux";

import { ReduxState } from "../../../types/redux.types";
import { AppResource } from "../../../types/resource.types";
import NotificationItems from "../NotificationsItems";
import { INotificationState } from "../notification.types";

const DropdownNotificationsListWrapper: ForwardRefExoticComponent<any> = forwardRef<any>((props: any, ref) => {
  const notifications = useSelector<ReduxState, INotificationState>((state) => state.notifications);

  const redirect = useRedirect();

  return (
    <div {...props} {...{ ref }}>
      <Box p={2} display="flex" justifyContent="space-between" alignItems="center">
        <Typography>Notifications</Typography>
        <Typography
          variant="body2"
          style={{
            cursor: "pointer",
            color: "blue",
            textDecoration: "underline",
          }}
          onClick={() => {
            redirect(`/${AppResource.notifications}`);
            props.handleClose();
          }}
        >
          See All
        </Typography>
      </Box>

      <Box width={380} overflow="hidden">
        <NotificationItems notifications={notifications} limit={5} handleClose={props.handleClose} />
      </Box>
    </div>
  );
});

export default DropdownNotificationsListWrapper;
